/** @jsx jsx */

import {
  Fragment as _,
  useContext,
  useState,
  cloneElement,
  useRef,
  useEffect,
} from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext as InteractionContext } from './interactionContext';
import { useSelector, useDispatch } from 'react-redux';
import { unlockInteraction } from 'services/unlockInteraction';
import hexToRgb from 'services/hexToRGB';
import { TextAreaDynamicHeight } from 'components/UI/TextAreaDynamicHeight';
import { State } from 'store/store';

const TextEntryVariable = props => {
  const interactionContext = useContext(InteractionContext);

  const {
    messageTextColor = '#000',
    messageBorderColor = '#B2B6CA' || '#d2dff9',
    messageFontFamily = 'inherit',
    messageFontSize = 16,
    messageTextBackgroundColor,
    messageTextBackgroundOpacity,
    variableName,
  } = interactionContext.props;

  const { children } = props;

  const [_submitBtn_] = children;

  const [isLive, setIsLive] = useState<boolean>(false);
  const [isSubmitted, setIsSubmitted] = useState<string>('');
  const [hasFocus, setHasFocus] = useState<boolean>(false);

  const dispatch = useDispatch();

  const moduleVariables = useSelector((state: State) => {
    return state.moduleVariables || {};
  });

  const message = useRef<string>(moduleVariables[variableName] || '');

  const { r, g, b } = hexToRgb(messageTextBackgroundColor);

  let a = messageTextBackgroundOpacity / 100;
  let backgroundColorRGBA = `rgba(${r}, ${g}, ${b}, ${a})`;

  const sharedStyles = {
    width: '100%',
    height: '100%',
    maxHeight: 240,
    padding: '5px 5px 5px 20px',
    fontFamily: messageFontFamily,
    fontSize: messageFontSize,
    color: messageTextColor,
    background: backgroundColorRGBA,
  };

  const submitBtn = cloneElement(_submitBtn_, {
    onClick() {
      dispatch({
        type: 'UPDATE_MODULE_VARIABLES',
        data: {
          [variableName]: message.current,
        },
      });

      setIsSubmitted(message.current);
    },
    enabled: !isSubmitted && isLive,
  });

  useEffect(() => {
    if (isSubmitted) {
      unlockInteraction(interactionContext.id);
    }
  }, [isSubmitted]);

  return (
    <div
      style={{
        width: '100%',
      }}
    >
      <div
        css={css({
          position: 'relative',
          color: messageTextColor,
          fontSize: messageFontSize,

          'textarea::placeholder': {
            color: messageTextColor,
          },

          'textarea:focus': {
            border: 'none !important',
            outline: 'none !important',
          },
        })}
      >
        <TextAreaDynamicHeight
          minHeight={35}
          maxLinesBeforeScrolling={5}
          placeholder="Type your response here..."
          onUpdate={value => {
            setIsSubmitted('');
            //
            setIsLive(!!value);

            message.current = value?.trim();
          }}
          //
          {...{
            onFocus() {
              // console.log('focus true');
              setHasFocus(true);
            },

            onBlur() {
              // console.log('focus false');
              setHasFocus(false);
            },

            name: variableName,
          }}
          initialValue={moduleVariables[variableName]}
        />
      </div>

      <div
        style={{
          width: '100%',
          height: 1,
          marginTop: 5,
          boxShadow: `0 0 0 ${hasFocus ? 1 : 0}px ${messageBorderColor}`,
          background: messageBorderColor,
          transition: 'box-shadow 0.3s',
        }}
      />
      <div
        style={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          margin: '20px 0 0 0',
        }}
      >
        {submitBtn}
      </div>
    </div>
  );
};

export default TextEntryVariable;
